import React from 'react'
import { Transaction, storedTransactionsAtom, isNotPending, isPending } from './transactions'
import { useAtomValue } from 'jotai'
import { isAddressEqual, zeroAddress } from 'viem'
import { userAccountAtom } from 'context/account'

interface PendingTransactionsContextResponse {
  pending: boolean
  completed: Transaction[]
}

const initialValue = {
  pending: false,
  completed: [],
}

const MultiTransactions = React.createContext<PendingTransactionsContextResponse>(initialValue)

export const PendingTransactionsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const transactions = useAtomValue(storedTransactionsAtom)
  const userAddress = useAtomValue(userAccountAtom)

  const [transactionList, setTransactionList] = React.useState(transactions)

  const value = {
    pending: transactionList
      .filter(({ account }) => isAddressEqual(account, userAddress ?? zeroAddress))
      .some(isPending),
    completed: transactionList
      .filter(({ account }) => isAddressEqual(account, userAddress ?? zeroAddress))
      .filter(isNotPending),
  }
  React.useEffect(() => {
    setTransactionList(transactions)
  }, [transactions])

  return <MultiTransactions.Provider value={value}>{children}</MultiTransactions.Provider>
}

export const useMultiTransactionState = () => {
  const context = React.useContext(MultiTransactions)
  if (context === undefined) {
    throw new Error('usePendingTransactions must be used within a PendingTransactionsProvider')
  }
  return context
}
